import { render, staticRenderFns } from "./loginversion.vue?vue&type=template&id=19b48218&scoped=true"
import script from "./loginversion.vue?vue&type=script&lang=js"
export * from "./loginversion.vue?vue&type=script&lang=js"
import style0 from "./loginversion.vue?vue&type=style&index=0&id=19b48218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b48218",
  null
  
)

export default component.exports